import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type { ApiResponse, RouterMachinesResponse } from "../../../shared/types/api";
import type { MachineDetail } from "../../../domain/types/machine-detail";
import type { MachineEntity } from "../../../domain/types/machine";

export interface ApiResponseMachineDetailList extends ApiResponse {
  data: MachineDetail[];
}

export interface ApiResponseMachineEntityList extends ApiResponse {
  data: MachineEntity[];
}

export class CompanyMachineApiService {
  async getMachineDetails(companyId: number): Promise<ApiResponseMachineDetailList> {
    const response = await httpClient.get<ApiResponseMachineDetailList>(
      NEW_API_ENDPOINTS.companyMachineController.GET(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 정보를 가져오지 못했습니다.");
    }

    return response.data;
  }

  async getMachineDetailsByRouter(companyId: number): Promise<ApiResponse<RouterMachinesResponse[]>> {
    const response = await httpClient.get<ApiResponse<RouterMachinesResponse[]>>(
      NEW_API_ENDPOINTS.companyRouterMachinesController.GET(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "장비 정보를 가져오지 못했습니다.");
    }

    return response.data;
  }
}

export const companyMachineApiService = new CompanyMachineApiService();